import React, { useCallback } from "react";
import { NumericMappingValues, VirtualConfig } from "../type";
import { Button, Form, Input, InputNumber, Row, Space } from "antd";
import { ArrowRightOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { indexToColor } from "../misc";

type NumericVirtualMappingInputProps = {
  value?: NumericMappingValues[];
  onChange?: (value: NumericMappingValues[]) => void;
};
const NumericVirtualMappingInput: React.FC<NumericVirtualMappingInputProps> = ({ value = [], onChange }) => {
  const updateIndex = useCallback(
    (index: number, key: keyof NumericMappingValues, newValue: any) => {
      const newCategories = [...value];
      newCategories[index] = { ...newCategories[index], [key]: newValue };
      onChange && onChange(newCategories);
    },
    [value, onChange],
  );
  function formatInfinity(value: number | string | undefined): string {
    if (value === undefined) return "";
    if (Number(value) === Number.MIN_SAFE_INTEGER) return "";
    if (Number(value) === Number.MAX_SAFE_INTEGER) return "";
    return `${value}`;
  }

  return (
    <div>
      {value.map((category, index) => (
        <Row key={index} style={{ marginBottom: 8, width: "100%" }}>
          <Space.Compact style={{ flexGrow: 1 }}>
            <InputNumber
              formatter={formatInfinity}
              style={{ minWidth: 100 }}
              onChange={(v) => updateIndex(index, "from", v || Number.MIN_SAFE_INTEGER)}
              value={category.from}
              placeholder="-∞"
              addonBefore={<span style={{ color: indexToColor(index) }}>[</span>}
            />
            <InputNumber
              placeholder="+∞"
              style={{ minWidth: 100 }}
              formatter={formatInfinity}
              onChange={(v) => updateIndex(index, "to", v || Number.MAX_SAFE_INTEGER)}
              value={category.to}
              addonBefore={<span style={{ color: indexToColor(index) }}>[</span>}
            />
            <Input
              style={{ minWidth: 200 }}
              addonBefore={<ArrowRightOutlined style={{ color: indexToColor(index) }} />}
              onChange={(e) => updateIndex(index, "name", e.target.value)}
              value={category.name}
            />
            <Button danger icon={<DeleteOutlined />} onClick={() => onChange && onChange(value.filter((_, i) => i !== index))} />
          </Space.Compact>
        </Row>
      ))}
      <Button
        icon={<PlusOutlined />}
        onClick={() =>
          onChange && onChange([...(value || []), { name: "", from: value[value.length - 1]?.to || 0, to: (value[value.length - 1]?.to || 0) + 1 }])
        }
      />
    </div>
  );
};

export default NumericVirtualMappingInput;
